import React from "react";
import { NavLink } from "react-router-dom";
import {
  FaTachometerAlt,
  FaFileAlt,
  FaKey,
  FaCreditCard,
  FaHistory,
  FaChartBar,
  FaUsers,
  FaCog,
  FaQuestionCircle,
} from "react-icons/fa";
import { ASSETS } from "../config/assets";

const Sidebar = ({ onNavClick }) => {
  const menuItems = [
    { icon: FaTachometerAlt, label: "Projects", path: "/all-projects" },
    { icon: FaFileAlt, label: "API Documentation", path: "/docs" },
    { icon: FaKey, label: "API Keys", path: "/keys" },
    { icon: FaCreditCard, label: "Billing", path: "/billing" },
    { icon: FaHistory, label: "Usage History", path: "/history" },
    { icon: FaChartBar, label: "Analytics", path: "/analytics" },
    { icon: FaUsers, label: "Team Management", path: "/team" },
    { icon: FaCog, label: "Settings", path: "/settings" },
    { icon: FaQuestionCircle, label: "Support", path: "/support" },
  ];

  return (
    <aside className="admin-sidebar">
      <nav className="admin-sidebar-nav">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === "/all-projects"}
            className={({ isActive }) =>
              `admin-sidebar-link${isActive ? " admin-sidebar-link-active" : ""}`
            }
            onClick={onNavClick}
          >
            <item.icon className="admin-sidebar-icon" size={18} />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="admin-sidebar-footer">
        <small className="version-text">{ASSETS.brandName} · Official WhatsApp API Partner</small>
      </div>
    </aside>
  );
};

export default Sidebar;
